import PasswordReset from "../components/PasswordReset/PasswordReset";
import useNavigation from "../hooks/navigation";
import { useRequestPasswordReset } from "../hooks/useAuth";

const PasswordResetContainer = () => {
  const navigation = useNavigation();

  const {
    error: requestPasswordResetError,
    isSuccess: isRequestResetPasswordSuccess,
    isPending: isRequestResetPasswordPending,
    mutate: mutateRequestResetPassword,
    reset: resetRequestPasswordReset,
  } = useRequestPasswordReset();

  const submit = (email: string, captcha: string) => {
    mutateRequestResetPassword({ email, captcha });
  };

  return (
    <PasswordReset
      onSubmit={submit}
      onReset={resetRequestPasswordReset}
      onBackClick={() => navigation.goToSignIn()}
      inProgress={isRequestResetPasswordPending}
      submitSuccess={isRequestResetPasswordSuccess}
      submitError={requestPasswordResetError}
    />
  );
};

export default PasswordResetContainer;
